import { useEffect, useRef } from "react";
import { voidRecord } from "@/lib/api";

function timeOf(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export default function ThreadView({ messages, currentUserId, onVoided }) {
  const foot = useRef(null);

  // Keep the newest message in view as the poll appends to the thread.
  useEffect(() => {
    foot.current?.scrollIntoView?.({ block: "end" });
  }, [messages.length]);

  const withdraw = async (message) => {
    // A message is not hidden by withdrawal: it stays in place and the body
    // is still served to both participants, only its rendering changes. The
    // default voidRecord() copy ("hides the record") would be false here.
    const done = await voidRecord(
      `/messages/${message.id}`,
      "this message",
      "It stays in the conversation and its content is still served — only how it renders changes.",
    );
    if (done) onVoided();
  };

  return (
    <div data-testid="thread-view" className="flex-1 overflow-y-auto px-4 py-3 space-y-2">
      {messages.map((message) => {
        const mine = message.sender_id === currentUserId;
        return (
          <div
            key={message.id}
            data-testid={`message-${message.id}`}
            className={`flex flex-col ${mine ? "items-end" : "items-start"}`}
          >
            <div
              className={`max-w-[85%] rounded-lg px-3 py-2 text-sm ${
                message.voided
                  ? "bg-slate-100 text-slate-500 italic"
                  : mine
                    ? "bg-slate-900 text-white"
                    : "bg-slate-100 text-slate-900"
              }`}
            >
              {/* A withdrawn message keeps its place in the conversation so the
                  record cannot be silently rewritten (FR-27). */}
              {message.voided
                ? `Message withdrawn — ${message.void_reason}`
                : message.body}
            </div>
            <div className="mt-0.5 flex items-center gap-2 text-[10px] text-slate-400">
              <span>{timeOf(message.created_at)}</span>
              {mine && !message.voided && (
                <button
                  onClick={() => withdraw(message)}
                  className="hover:text-status-critical transition-colors duration-200"
                >
                  Withdraw
                </button>
              )}
            </div>
          </div>
        );
      })}
      <div ref={foot} />
    </div>
  );
}
